module.exports = __webpack_public_path__ + "img/logo-garaging.5c54c669.png";